import { useTranslation } from 'react-i18next';

import { getShareIncidentRelatedAgencies } from '@ngsos/portal-core/agency';

import { NgButton } from '@/ui';
import { useAgencyConfiguration } from '@/app/shell/agencyConfiguration';

export type IncidentDetailActionBarItemsProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  onAddAgencyToIncident: () => void | Promise<void>;
  onOpenShareByLinkDialog: () => void | Promise<void>;
  onCloseIncident: () => void | Promise<void>;
};

export function IncidentDetailActionBarItems({
  incidentIsReadOnly,
  onAddAgencyToIncident,
  onOpenShareByLinkDialog,
  onCloseIncident,
}: IncidentDetailActionBarItemsProps) {
  const { t } = useTranslation();
  const agencyConfiguration = useAgencyConfiguration();
  const relatedAgencies = getShareIncidentRelatedAgencies(agencyConfiguration);

  return (
    <>
      {!incidentIsReadOnly && relatedAgencies.length > 0 && (
        <NgButton
          text={t('Incident_Button_AddAgencyToIncident')}
          outline
          icon="fal fa-phone-plus"
          onClick={onAddAgencyToIncident}
        />
      )}

      <NgButton
        text={t('Incident_Button_ShareViaLink')}
        outline
        icon="fal fa-share-from-square"
        onClick={onOpenShareByLinkDialog}
      />

      {!incidentIsReadOnly && (
        <NgButton
          text={t('Incident_Button_CloseIncident')}
          outline
          type="danger"
          icon="fal fa-xmark"
          confirmationMessage={t('Incident_Button_CloseIncident_Confirmation')}
          onClick={onCloseIncident}
          enableMultipleClickPrevention
        />
      )}
    </>
  );
}
